import React from "react"
import { Grid } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { createTheme, useTheme } from "@material-ui/core/styles"
import DocomoLogo from "assets/images/DocomoLogo.svg"
import DocomoFinancialLogo from "assets/images/DocomoFinancialLogo.png"
const useStyles = makeStyles(
  theme => ({
    logo: {
      display: "block",
      height: "37px",
      width: "auto",
    },
  }),
  { defaultTheme: createTheme() }
)

const HeaderLogo = props => {
  const theme = useTheme()
  const classes = useStyles(theme)
  return (
    <Grid container direction="row" alignItems="center" wrap="nowrap">
      <img src={DocomoLogo} alt="docomotitle" className={classes.logo} />
      <img
        src={DocomoFinancialLogo}
        alt="docomofinancialtitle"
        className={classes.logo}
      />
    </Grid>
  )
}

export default HeaderLogo
